<template>
    <v-container fill-height fluid grid-list-xl>
        <v-layout justify-center wrap>
            ssss
        </v-layout>
    </v-container>
</template>

<script>

export default {  
  props:{
    platforms:Array
  },
  data() {
    return {
      
    }
  }
}
</script>